const DEFAULT_TICKETS_URL = "https://tickets.usependpay.com";

export function getTicketsBaseUrl() {
  const fromEnv = String(process.env.REACT_APP_TICKETS_URL || "")
    .trim()
    .replace(/\/$/, "");
  return fromEnv || DEFAULT_TICKETS_URL;
}

export function buildEventShareUrl(eventId) {
  return `${getTicketsBaseUrl()}/e/${encodeURIComponent(eventId)}`;
}

export function buildEventShareMessage(title, eventId) {
  const url = buildEventShareUrl(eventId);
  const name = String(title || "this event").trim() || "this event";
  return `Check out ${name} on PendPay Tickets:\n${url}`;
}

export async function shareEventLink(title, eventId) {
  const url = buildEventShareUrl(eventId);
  const text = buildEventShareMessage(title, eventId);
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({ title: title || "PendPay Tickets", text, url });
      return { ok: true, method: "share" };
    } catch (err) {
      if (err?.name === "AbortError") return { ok: false, method: "share", aborted: true };
    }
  }
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return { ok: true, method: "clipboard", url };
  }
  return { ok: false, method: "none", url };
}
